import { p as c, A as u, c as o, C as t, d as g, a as s } from "./@aws-amplify-21547700.js";
const A = {
  /**
   * Configures Amplify with the {@link resourceConfig} and {@link libraryOptions}.
   *
   * @param resourceConfig The {@link ResourcesConfig} object that is typically imported from the
   * `amplifyconfiguration.json` file. It can also be an object literal created inline when calling `Amplify.configure`.
   * @param libraryOptions The {@link LibraryOptions} additional options for the library.
   *
   * @example
   * import config from './amplifyconfiguration.json';
   *
   * Amplify.configure(config);
   */
  configure(n, e) {
    const f = c(n);
    if (!f.Auth) {
      u.configure(f, e);
      return;
    }
    if (e != null && e.Auth) {
      u.configure(f, e);
      return;
    }
    if (!u.libraryOptions.Auth) {
      o.setAuthConfig(f.Auth), o.setKeyValueStorage(
        // TODO: allow configure with a public interface
        e != null && e.ssr ? new t({ sameSite: "lax" }) : g
      ), u.configure(f, {
        ...e,
        Auth: {
          tokenProvider: o,
          credentialsProvider: s
        }
      });
      return;
    }
    if (e) {
      e.ssr !== void 0 && o.setKeyValueStorage(
        // TODO: allow configure with a public interface
        e.ssr ? new t({ sameSite: "lax" }) : g
      ), u.configure(f, {
        Auth: u.libraryOptions.Auth,
        ...e
      });
      return;
    }
    u.configure(f);
  },
  /**
   * Returns the {@link ResourcesConfig} object passed in as the `resourceConfig` parameter when calling
   * `Amplify.configure`.
   *
   * @returns An {@link ResourcesConfig} object.
   */
  getConfig() {
    return u.getConfig();
  }
};
export {
  A as D
};
